module.exports = __webpack_public_path__ + "img/bus.18880b2f.png";